import React, { createContext, useContext, useState } from 'react'

const STORAGE_KEY = 'cream_currency'
const SUPPORTED = ['EUR', 'MKD', 'USD']

const CurrencyContext = createContext(null)

const getInitialCurrency = () => {
  if (typeof window === 'undefined') return 'EUR'
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return SUPPORTED.includes(stored) ? stored : 'EUR'
}

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(getInitialCurrency)

  const setCurrency = (next) => {
    if (!SUPPORTED.includes(next)) return
    window.localStorage.setItem(STORAGE_KEY, next)
    setCurrencyState(next)
  }

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export const useCurrency = () => useContext(CurrencyContext)
